import { Injectable } from "@angular/core";
import { BehaviorSubject, Observable } from "rxjs";
import { ChatFabEnabledDao } from "@app/core/user/data/local/chat-fab-enabled.dao";
import { ChatFabEnabledRepo } from "@app/core/user/domain/repositories/chat-fab-enabled.repo";

@Injectable({
  providedIn: "root",
})
export class ChatFabEnabledDataRepo implements ChatFabEnabledRepo {
  constructor(private chatFabEnabledDao: ChatFabEnabledDao) {}

  private readonly chatFabEnabledSubject = new BehaviorSubject<boolean>(
    this.chatFabEnabledDao.getChatFabEnabled()
  );

  setChatFabEnabled(enabled: boolean): void {
    this.chatFabEnabledDao.setChatFabEnabled(enabled);
    this.chatFabEnabledSubject.next(enabled);
  }

  observeChatFabEnabled(): Observable<boolean> {
    return this.chatFabEnabledSubject.asObservable();
  }
}
